// Copyright (c) Move Closer 2023.

import { Component, Inject as VueInject, PropSync, Vue } from 'vue-property-decorator'
import { EventbusType, IEventbus } from '@movecloser/front-core'
import { SubscribeConfig } from '@kluseg/trackify'

import { defaultProvider, Inject, IS_MOBILE_PROVIDER_KEY } from '../../../support'

import { NewsletterFormState } from '../Newsletter.contracts'
import { NewsletterModuleConfig } from '../Newsletter.config'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
@Component({
  name: 'NewsletterModuleMixin'
})
export class NewsletterModuleMixin extends Vue {
  @VueInject({ from: IS_MOBILE_PROVIDER_KEY, default: () => defaultProvider<boolean>(false) })
  public readonly isMobileDevice!: () => boolean

  @Inject(EventbusType)
  protected readonly eventBus!: IEventbus

  @PropSync('configuration', { type: Object, required: true })
  public readonly _config!: NewsletterModuleConfig

  public formData: SubscribeConfig = {
    email: '',
    name: ''
  }

  public isLoading: boolean = false
  public message: string = ''
  public state: NewsletterFormState | null = null
  public errors: Array<string> = []

  /**
   * Theme of alert.
   */
  public get theme (): string {
    return (this.state === NewsletterFormState.Error || !this.state) ? 'danger' : 'success'
  }

  /**
   * Clears current state.
   */
  public clearState (): void {
    this.state = null
  }
}
